module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 99 && _vm.brandSelect !== '99' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('dis-item-table', {
    attrs: {
      "storeId": _vm.storeSelect
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d0cb3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/DisItemTableOld.vue
// module id = 2359
// module chunks = 1